export const getAllLearnosityItems = stringValue => {
  if (!stringValue || typeof stringValue !== 'string') return null;

  const commaSeparatedString = stringValue
    .split('\n')
    .filter(_string => _string !== '')
    .map(_string => {
      try {
        return JSON.parse(_string || `"${_string}"`);
      } catch (e) {
        return _string;
      }
    });

  return commaSeparatedString.filter(learnosityItem => learnosityItem !== '');
};
